export default __webpack_public_path__ + "static/media/fundamentos-prod-digitais.7eb00f96.png";